<template>
  <div>
    <MenuBar />
    <section>
      <div class="container">
        <div class="content-wrapper">
          <div class="box">
            <div class="card-content">
              <div class="content">
                <div class="columns">
                  <div class="column is-8">
                    <h1 class="is-size-3 has-text-weight-semibold">
                      Import your bookmarks
                    </h1>

                    <p>
                      We do our best to import bookmarks from most of the bookmarking services or browsers.<br>
                      Just upload here the html file with your bookmarks:
                    </p>

                    <b-field
                      class="file is-primary"
                      :class="{'has-name': !!file}"
                    >
                      <b-upload
                        v-model="file"
                        class="file-label"
                        drag-drop
                        @input="inputChanged"
                      >
                        <span class="file-cta">
                          <b-icon
                            class="file-icon"
                            icon="upload"
                          />
                          <span class="file-label">Click to upload</span>
                        </span>
                        <span
                          v-if="file"
                          class="file-name"
                        >
                          {{ file.name }}
                        </span>
                      </b-upload>
                    </b-field>

                    <div class="import-tips">
                      <h4>Tips for exporting:</h4>
                      <ul>
                        <li>
                          <h5><span class="export-tips-icon tips-delicious" /> Delicious:</h5>
                          <p>
                            Login and go to <a
                              target="_blank"
                              href="https://del.icio.us/export"
                            >https://del.icio.us/export</a>. (service known for being down often)
                          </p>
                        </li>
                        <li>
                          <h5><span class="export-tips-icon tips-chrome" /> Chrome:</h5>
                          <p>
                            Go to your browser bookmarks (<a
                              target="_blank"
                              href="chrome://bookmarks/"
                            >chrome://bookmarks/</a>) and click the 'Organize' menu (middle of the screen) and choose 'Export Bookmarks'
                          </p>
                        </li>
                        <li>
                          <h5><span class="export-tips-icon tips-safari" /> Safari:</h5>
                          <p>Go to menu 'File' and choose 'Export Bookmarks'</p>
                        </li>
                      </ul>
                    </div>

                    <p class="is-size-7">
                      Note: duplicated bookmarks won't be imported.
                    </p>
                  </div>
                  <div class="column is-4 is-hidden-mobile">
                    <div class="import-image-holder">
                      <b-image :src="require('@/assets/images/import_file.png')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import MenuBar from "@/views/_globals/MenuBar.vue"
  import { ToastProgrammatic as Toast } from 'buefy'

  export default {
    name: 'ImportBookmarks',
    components: {
      MenuBar
    },
    data() {
      return {
        file: null
      }
    },
    methods: {
      save(args) {
        return this.$store.dispatch(`imports/save`, args)
      },
      inputChanged() {
        const file = this.file
        this.save({form: {file: file}}).then(function(response){
          if (response) {
            // const responseId = response.data.bookmarks.id
            // vm.$router.go(-1)
            Toast.open({
              message: "Import file successfully uploaded. We will start processing your bookmarks and notify you through email as soon as it finishes.",
              position: 'is-bottom',
              type: 'is-success'
            })
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .export-tips-icon {
    text-align: left;
    background-repeat: no-repeat;
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: inline-block;
    background-size: contain;
    margin-right: 6px;
  }

  .tips-chrome { background-image: url('~@/assets/images/export-tips/chrome.png'); }
  // .tips-firefox { background-image: url('@/images/export-tips/firefox.png'); }
  .tips-safari { background-image: url('~@/assets/images/export-tips/safari.png'); }
  // .tips-ie { background-image: url('@/images/export-tips/ie.png'); }
  .tips-delicious { background-image: url('~@/assets/images/export-tips/delicious.png'); }
</style>
